











































import Modal from 'frontend/components/Modal.vue';
import { LearningPathV2, LearningPathLevel, LevelCourse } from 'frontend/types/learningPathV2';
import { TrackingConfig } from 'frontend/utils/directives';
import CircleCheckMarkIcon from 'frontend/components/icons/CircleCheckMarkIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressBar from './ProgressBar.vue';
import { mapGetters } from 'vuex';

@Component({
  components: { CircleCheckMarkIcon, Modal, ProgressBar },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CoursesModal extends Vue {
  @Prop({ type: Object, required: true })
  private level!: LearningPathLevel;
  @Prop({ type: Object, required: true })
  private learningPath!: LearningPathV2;

  private get continueCourseSlug(): string {
    const { courses } = this.level;
    const firstIncompleteCourseIndex = courses.findIndex(c => !this.isComplete(c));
    if (firstIncompleteCourseIndex === -1) return courses[0].slug;
    return courses[firstIncompleteCourseIndex].slug;
  }

  private courseClickParams(course: LevelCourse): TrackingConfig {
    return {
      axId: 'clicked_start_course_on_learning_path',
      axExtra: {
        course_id: course.id,
        course_name: course.name,
      },
    };
  }

  private isComplete(course: LevelCourse): boolean {
    return course.percent_complete === 100;
  }
}
